import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { StoryblokImage } from 'matchmaking/models';

@Component({
    selector: 'matchmaking-form-image',
    imports: [],
    templateUrl: './form-image.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './form-image.component.scss'
})
export class FormImageComponent {
    @Input()
    image!: StoryblokImage;
}
